import { render, staticRenderFns } from "./CertificatesTraining.vue?vue&type=template&id=c50cfd26"
import script from "./CertificatesTraining.vue?vue&type=script&lang=js"
export * from "./CertificatesTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports